module.exports = __webpack_public_path__ + "static/media/square-button-red.90b3ee0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/buttons/square-button-red.png
// module id = 995
// module chunks = 0